<template>
     <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title">
              <span class="badge badge-pill badge-info">LIVE Stream Details</span>
            </h5>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>

          <div class="card-footer">
            <div class="row">
              <div class="col-sm-6 col-12">
                <div class="description-block">
                  <table class="table table-sm">
                    <tbody>
                      <tr>
                        <td>Username:</td>
                        <td class="float-left">
                          <span id="user">{{station.dj_username}}</span>
                          <copy-to-clipboard-button target="#user" hide-text></copy-to-clipboard-button>
                        </td>
                      </tr>
                      <tr>
                        <td>Password:</td>
                        <td class="float-left">
                          <span id="password">{{station.dj_password}}</span>
                          <copy-to-clipboard-button target="#password" hide-text></copy-to-clipboard-button>
                        </td>
                      </tr>
                        <tr>
                        <td>Server Port:</td>
                        <td class="float-left">
                          <span id="cluster_dj_port">{{station.cluster_dj_port}}</span>
                          <copy-to-clipboard-button target="#cluster_dj_port" hide-text></copy-to-clipboard-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.description-block -->
              </div>
              <!-- /.col -->

              <!-- /.col -->
              <div class="col-sm-6 col-12">
                <div class="description-block">
                  <table class="table table-sm">
                    <tbody>
                      <tr>
                        <td>Address (Server):</td>
                        <td class="float-left">
                          <span id="address">{{station.server_address}}</span>
                          <copy-to-clipboard-button target="#address" hide-text></copy-to-clipboard-button>
                        </td>
                      </tr>
                      <tr>
                        <td>MountPoint:</td>
                        <td class="float-left">
                          <span id="mount">{{station.mount_name}}</span>
                          <copy-to-clipboard-button target="#mount" hide-text></copy-to-clipboard-button>
                        </td>
                      </tr>
                       
                    </tbody>
                  </table>
                </div>
                <!-- /.description-block -->
              </div>
            </div>
            <!-- /.row -->
          </div>
          <!-- /.card-footer -->
        </div>
        <!-- /.card -->

        <div class="card">
          <div class="card-header">
            <h5 class="card-title">
              <span class="badge badge-pill badge-info">Third Party Software</span>
            </h5>
            <div class="card-tools">
              <button type="button" class="btn btn-tool" data-card-widget="collapse">
                <i class="fas fa-minus"></i>
              </button>
            </div>
          </div>

          <div class="card-footer">
            <div class="row">
              <div class="col-sm-6 col-12">
                <div class="description-block">
                  <table class="table table-sm">
                    <tbody>
                      <tr>
                        <td>BUTT:</td>
                        <td class="float-left">
                          <span id="software_butt">
                          <a target="_blank" href="https://sourceforge.net/projects/butt/files/butt/">https://sourceforge.net/projects/butt/files/butt/</a>
                          </span>
                          <copy-to-clipboard-button target="#software_butt" hide-text></copy-to-clipboard-button>
                        </td>
                      </tr>

                       <tr>
                        <td>MIXXX:</td>
                        <td class="float-left">
                          <span id="software_mixxx">
                          <a target="_blank" href="https://mixxx.org/download/">https://mixxx.org/download/</a>
                          </span>
                          <copy-to-clipboard-button target="#software_mixxx" hide-text></copy-to-clipboard-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.description-block -->
              </div>
              <!-- /.col -->

            </div>
            <!-- /.row -->
          </div>
          <!-- /.card-footer -->
        </div>
        <!-- /.card -->
      </div>
</template>

<script>
import CopyToClipboardButton from '@/components/common/CopyToClipboardButton';

export default {
  
  components:{
    CopyToClipboardButton

  }
}
</script>
<style scoped>
.table th, .table td {
  
    border-top: none
}
</style>